import { createComponent } from '@carvana/merch-components';

export const PromoTileWrapper = createComponent('div', {
  className:
    'flex flex-col items-center justify-center gap-24 m:w-full m:flex-row m:items-stretch'
});
